import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import { API_URL } from '@/config'

const mixins = Vue.mixin({

  computed: {
    ...mapState(['language', '_', 'progress', 'response', 'confirm', 'authorized']),
  },

  methods: {

    ...mapMutations(['setProgress', 'clearResponse', 'setModal', 'setDetails', 'setConfirm', 'setConflicts']),

    showDetails(details) {
      this.setDetails({ model: details.model, id: details.id });
      this.setModal({ status: true, component: 'Details' });
    },

    showConfirm(confirm) {
      this.setConfirm({ model: confirm.model, id: confirm.id, action: confirm.action });
      this.setModal({ status: true, component: 'Confirm' });
    },

    showConflicts(conflicts) {
      this.setConflicts({ model: conflicts.model, id: conflicts.id, type: conflicts.type });
      this.setModal({ status: true, component: 'Conflicts' });
    },

    async deleteItem() {
      let route = this.confirm.model + 's';
      let action = this.confirm.action;
      await Vue.axios.delete(API_URL + '/' + route + '/' + this.confirm.id);
      this.$store.commit('setProgress', false);
      this.$store.commit('closeModal');
      if (action.path !== this.$route.path) {
        this.$router.push(action.path);
      } else {
        this.$store.commit(route + '/clearList');
        this.$store.dispatch(route + '/getList');
      }
    },

    formatDate(day) {
      return this._.date_format_schedule
        .replace('&day', this._[day.day_name])
        .replace('&d', day.day)
        .replace('&month', this._[day.month_name])
        .replace('&y', day.year) || '';
    },

    formatTime(time) {
      let hours = '0' + Math.floor((time / 60) / 60);
      let minutes =  '0' + ((time / 60) % 60);
      return hours.substr(-2) + ':' + minutes.substr(-2);
    },

    satisfyDependency(dependency, namespace) {
      if (dependency) {
        let column = dependency.split(':')[0]
        let values = dependency.split(':')[1].split(',').map(i => parseInt(i));
        return values.includes(parseInt(this.$store.state[namespace].values[column]));
      } else {
        return true;
      }
    },

  }
})

export default mixins
